import { ImageField, LinkField, StringField, THeadingTag } from '../../../types/types';
import { HeroBannerFields, HeroBannerProps } from '../types/heroBanner.types';

export class HeroBannerModel {
  private readonly fields?: HeroBannerFields;
  private readonly params?: ComponentParamsGeneral;

  constructor(props: HeroBannerProps) {
    this.fields = props?.fields;
    this.params = props?.params;
  }

  get description(): StringField | undefined {
    return this.fields?.description;
  }

  get eyebrow(): StringField | undefined {
    return this.fields?.eyebrow;
  }

  get image(): ImageField | undefined {
    return this.fields?.image;
  }

  get mobileImage(): ImageField | undefined {
    return this.fields?.mobileImage;
  }

  get primaryLink(): LinkField | undefined {
    return this.fields?.link1;
  }

  get secondaryLink(): LinkField | undefined {
    return this.fields?.link2;
  }

  get title(): StringField | undefined {
    return this.fields?.title;
  }

  get textColor(): 'Black' | 'White' {
    return this.fields?.textColor?.fields?.Key?.value || 'White';
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

  get isGradientDisabled(): boolean | undefined {
    return this.params?.disableGradient === '1';
  }

  get headingTag(): THeadingTag {
    return (this.params?.headingTag?.toLowerCase() as THeadingTag) || 'h1';
  }
}
